<div class="step_container">
  <div class="main_header">
    <label class="name_label">Basic Setup</label>
  </div>

  <div class="main_container">
    <div class="flex_row">
      <mat-form-field
        class="input-filed name_field"
        appearance="outline"
        floatLabel="always"
        [hideRequiredMarker]="false"
      >
        <mat-label> Name </mat-label>
        <input
          (keyup)="validate()"
          [(ngModel)]="conversionPixel.name"
          [maxLength]="255"
          autocomplete="off"
          style="height: auto"
          matInput
          required
          type="text"
          placeholder="Enter name"
        />
        <mat-error> Name is required </mat-error>
      </mat-form-field>
    </div>

    <div class="field-name mt-4">
      Dynamic parameters
      <span
        matTooltip="Dynamic Parameters allow you to define tracking rules for each user.
          You can add up to 10 custom parameters and one of each predefined parameter."
        matTooltipClass="tooltip-class"
        class="material-icons tool-tip ms-1"
      >
        error
      </span>
    </div>
    <p class="bold">
      Add dynamic parameters
      <mat-slide-toggle
        class="ms-2"
        [(ngModel)]="conversionPixel.containsParam"
        (ngModelChange)="containsParamChanged()"
      >
      </mat-slide-toggle>
    </p>
    <ng-container *ngIf="conversionPixel.containsParam">
      <table
        class="dynamic-params"
        mat-table
        [dataSource]="dataSourceParameters"
      >
        <ng-container matColumnDef="type">
          <th mat-header-cell *matHeaderCellDef>
            <div class="table-checkboxes">Parameters</div>
          </th>
          <td mat-cell *matCellDef="let row; let index = index">
            <span class="table_value_name">
              <mat-form-field
                class="me-3"
                appearance="outline"
                floatLabel="always"
                [hideRequiredMarker]="false"
              >
                <mat-label>Parameter</mat-label>
                <mat-select
                  required
                  #selector
                  disableOptionCentering
                  [multiple]="false"
                  [(ngModel)]="row.type"
                  (selectionChange)="validate()"
                >
                  <mat-option
                    *ngFor="let parameter of parameterOptions"
                    [value]="parameter"
                    [disabled]="isDynamicParamSelected(parameter)"
                  >
                    {{ parameter.split("_").join(" ") | titlecase }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="value">
          <th mat-header-cell *matHeaderCellDef>
            <div class="table-checkboxes">Value</div>
          </th>
          <td mat-cell *matCellDef="let row; let index = index">
            <span class="table_value_name">
              <mat-form-field
                class="input_field"
                appearance="outline"
                floatLabel="always"
                [hideRequiredMarker]="false"
              >
                <mat-label>Value</mat-label>
                <input
                  (keyup)="validate()"
                  required
                  [maxLength]="255"
                  style="height: auto"
                  matInput
                  type="text"
                  [(ngModel)]="row.value"
                  autocomplete="off"
                  placeholder="Enter value"
                />
              </mat-form-field>
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="cancel">
          <th mat-header-cell *matHeaderCellDef>
            <div class="table-checkboxes"></div>
          </th>
          <td mat-cell *matCellDef="let row; let index = index">
            <span class="table_value_name">
              <button
                (click)="removeDynamicParams(index)"
                class="cancel_button me-2"
                mat-mini-fab
              >
                <span class="material-icons"> close </span>
              </button>
              <button
                *ngIf="
                  conversionPixel.dynamic_parameters.length <= 12 &&
                  index == conversionPixel.dynamic_parameters.length - 1
                "
                (click)="addDynamicParams()"
                class="create-btn plus_button"
                mat-mini-fab
              >
                +
              </button>
            </span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="parameterColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: parameterColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" colspan="13">No data available</td>
        </tr>
      </table>
    </ng-container>
  </div>

  <div class="main_footer align_right">
    <button
      mat-button
      class="action_btn_no-border me-2 mb-2"
      (click)="goHome()"
    >
      Cancel
    </button>

    <button
      *ngIf="
        commonService.displayEntitySaveBtn(isEdit, stepInput.editPermission)
      "
      (click)="proceed()"
      mat-button
      class="create-btn me-2 mb-2"
      [disabled]="!isValid"
      [ngClass]="{
        'create-btn-disabled': !isValid,
        'create-btn': true,
        'me-2': true
      }"
    >
      Save
    </button>
  </div>
</div>
